import store from "../../store/store";
const userPermissions =
  store.state.auth.user && store.state.auth.user.user.user_permission;
export const authPermission = {
  mounted(el, binding, vnode) {
    const { value } = binding;
    if (!checkPermission(value.routeName, value.action)) {
      commentNode(el, vnode);
      // el.style.setProperty("display", "none", "important"); // Hide the element if the user doesn't have the required permission
    }
  },
};

function checkPermission(requiredPermission, action) {
  if (userPermissions && userPermissions[requiredPermission]) {
    return userPermissions[requiredPermission][action];
  }
  return true;
}

/**
 * Create comment node
 *
 * @private
 * @author https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs#43543814
 */
function commentNode(el, vnode) {
  const comment = document.createComment(" ");

  Object.defineProperty(comment, "setAttribute", { value: () => undefined });

  vnode.text = " ";
  vnode.elm = comment;
  vnode.isComment = true;
  vnode.tag = undefined;
  // vnode.data.directives = undefined

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment;
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}
